import { Maybe, just, nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../EmptyFragment';
import OrganizationFilter from '../../People/Filters/OrganizationFilter';
import LearningCollectionsStore from '../Store';
import { LearningCollectionSummariesResource } from '../Types';
import LearningCollectionSort from './LearningCollectionSort';
import OwnerFilter from './OwnerFilter';
import StatusFilter from './StatusFilter';

interface Props {
  store: LearningCollectionsStore;
  data: LearningCollectionSummariesResource;
}

type Zeroable = number;

const fromCount = <T extends Zeroable>(xs: T): Maybe<T> => (xs <= 0 ? nothing<T>() : just(xs));

function FiltersAndSorting({ store, data }: Props) {
  const state = store.state;
  const count = data.metadata.totalUnfilteredCount;

  return fromCount(count)
    .map(() => (
      <div className="flex flex-col justify-between py-5 px-2.5 md:flex-row lg:px-12">
        <div className="flex flex-col md:flex-row">
          <StatusFilter
            searchParameters={state.searchParameters}
            updatingSearchParameters={store.updatingSearchParameters}
          />
          <OrganizationFilter
            updatingOrganizationParameters={store.updatingOrganizationParameters}
            selectedOrganization={state.selectedOrganization}
            className="ml-4"
          />
          <OwnerFilter
            searchParameters={state.searchParameters}
            updatingSearchParameters={store.updatingSearchParameters}
            learningCollectionSummariesResource={data}
          />
        </div>
        <LearningCollectionSort store={store} sortParameters={state.sortParameters} />
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(FiltersAndSorting);
